<template>
  <div id="app">
    <nav class="site-nav">
      <div class="content-wrap">
        <router-link class="site-nav__logo" to="/">
          Tarski
          <span class="icon baseline">
            <svg viewBox="-50 -50 100 100"><polygon class="only-lines" fill="none"
                                                    points="-20,36 -40,0 -20,-36 20,-36 40,0 20,36"/></svg>
          </span>
          <span class="icon baseline">
            <svg viewBox="-50 -50 100 100"><polygon class="only-lines" fill="none"
                                                    points="-35,35 35,35 35,-35,-35,-35"/></svg>
          </span>
          <span class="icon baseline">
            <svg viewBox="-50 -50 100 100"><polygon class="only-lines" fill="none" points="-40,35 0,-35 40,35"/></svg>
          </span>
        </router-link>
        <ul class="site-nav__links">
          <li>
            <router-link to="/">Play</router-link>
          </li>
          <li>
            <router-link to="/explore">Explore</router-link>
          </li>
          <li>
            <router-link to="/highscores">Scores</router-link>
          </li>
          <li>
            <router-link to="/tutorial">Intro</router-link>
          </li>
          <li>
            <router-link to="/contact">Contact</router-link>
          </li>
          <li>
            <router-link to="/account">Account</router-link>
          </li>
        </ul>
      </div>
    </nav>
    <main id="page-wrap" :class="{
      'page-wrap--explore': $route.path === '/explore',
      'page-wrap--fullscreen': ['/test', '/swap', '/explore'].includes($route.path) || $route.path.startsWith('/dare'),
    }">
      <div class="content-wrap">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>
